/* eslint-disable max-len */

export const ClockIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g fill="none" fillRule="evenodd">
    <path fill="#A2A4B2" fillRule="nonzero" d="M17.3 7.4L12 12.7 8 9.6c-.4-.4-1-.3-1.4.1-.3.4-.3 1.1.2 1.4l4.6 3.7c.2.2.4.2.6.2.3 0 .5-.1.7-.3l6-6c.4-.4.4-1 0-1.4-.4-.3-1.1-.3-1.4.1zM12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10z" />
  </g>
</svg>;

export const LetterIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18">
  <g fill="none" fillRule="evenodd">
    {/* <path d="M0 0H24V24H0z" transform="translate(0 -3)" /> */}
    <path fill="#A2A4B2" fillRule="nonzero" d="M22.5 3c.8 0 1.5.7 1.5 1.5v15c0 .8-.7 1.5-1.5 1.5h-21C.7 21 0 20.3 0 19.5v-15C0 3.7.7 3 1.5 3zM22 5H2v14h20V5zM4.3 7.3c.4-.4 1-.4 1.4 0l6.3 6.3 6.3-6.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L16.4 12l3.3 3.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.2 0-.5-.1-.7-.3L15 13.4l-3 3-3-3-3.3 3.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4L7.6 12 4.3 8.7c-.4-.4-.4-1 0-1.4z" transform="translate(0 -3)" />
  </g>
</svg>;

export const PhoneCallIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g fill="none" fillRule="evenodd">
    <path fill="#A2A4B2" fillRule="nonzero" d="M13 7c2.2.1 3.9 1.9 4 4 0 .5.5 1 1 1 .6 0 1-.5 1-1-.1-3.2-2.7-5.8-5.9-6-.5 0-1 .4-1 1-.1.5.3 1 .9 1zm-1-7c-.6 0-1 .4-1 1s.4 1 1 1c5.5 0 10 4.5 10 10 0 .6.4 1 1 1s1-.4 1-1c0-6.6-5.4-12-12-12zm4 14c-2 0-3.7 1.2-4.5 2.9-1.9-1-3.4-2.5-4.4-4.4C8.8 11.7 10 10 10 8c0-2.8-2.2-5-5-5S0 5.2 0 8c0 8.8 7.2 16 16 16 2.8 0 5-2.2 5-5s-2.2-5-5-5zm0 8C8.3 22 2 15.7 2 8c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.4-1 2.7-2.4 2.9l-1.2.2.4 1.1c1.2 3.2 3.7 5.7 6.9 6.9l1.1.4.2-1.2c.3-1.3 1.6-2.3 3-2.3 1.7 0 3 1.3 3 3s-1.3 3-3 3z" />
  </g>
</svg>;


//──── User default images ───────────────────────────────────────────────────────────────
export const UserPhotoDefault = () => <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
  <g fill="none" fillRule="evenodd">
    <circle cx="60" cy="60" r="60" fill="#F5F5F9" />
    <path fill="#A2A4B2" fillRule="nonzero" d="M48 51.934c0-6.573 5.4-11.95 12-11.95 6.2 0 11.4 4.78 12 10.755-3.4 1.593-8 1.792-11.6.398-2.8-1.195-5-3.187-5.4-5.378-1.2.996-2 2.191-2.6 3.785 1.2 2.39 3.4 4.182 6.4 5.377 2.2.797 4.4 1.195 6.8 1.195 2.2 0 4.4-.398 6.4-.996v10.756h4V51.934C76 43.17 68.8 36 60 36s-16 7.17-16 15.934v13.942h4V51.934zm24.4 20.713c-.6-.199-1-.398-1.6-.597l-1.2-.598-1 .996c-4.8 4.581-12.4 4.581-17.2 0l-1-.996-1.2.598c-.6.199-1 .398-1.6.597-4.2 1.793-9.6 3.984-9.6 11.154h4c0-4.382 2.6-5.577 7.2-7.37.2 0 .2-.199.4-.199 6 4.98 14.8 4.98 20.8 0 .2 0 .2.2.4.2C75.4 78.224 78 79.618 78 84h4c0-7.37-5.4-9.56-9.6-11.353z" />
  </g>
</svg>;


export const DoctorPhotoDefault = () => <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
  <g fill="none" fillRule="evenodd">
    <circle cx="20" cy="20" r="20" fill="#F5F5F9" />
    <path fill="#A2A4B2" fillRule="nonzero" d="M31 12c-.1-1.4-1.3-3-3-3h-2c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1 .6 1 1.1 0 .3-.1.6-.3.8L22 21.4l-6.8-8.5c-.1-.2-.2-.6-.2-.8 0-.5.4-1.1 1-1.1h2c.6 0 1-.4 1-1s-.4-1-1-1h-2c-1.7 0-2.9 1.5-3 3 0 .8.2 1.6.7 2.2l7.3 9.3V27c0 1.1-.9 2-2 2s-2-.9-2-2v-4.5c0-1.4-1.1-2.5-2.5-2.5h-1.7c-.4-1.2-1.5-2-2.8-2-1.7 0-3 1.3-3 3s1.3 3 3 3c1.3 0 2.4-.8 2.8-2h1.7c.3 0 .5.2.5.5V27c0 2.2 1.8 4 4 4s4-1.8 4-4v-3.7l7.3-9.2c.5-.6.7-1.4.7-2.1zM10 22c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" />
  </g>
</svg>;



//──── Camera ────────────────────────────────────────────────────────────────────────────
export const CamIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16">
  <g fill="none" fillRule="evenodd">
    <path d="M0 0H24V24H0z" transform="translate(-1 -4)" />
    <path
      fill="#4A90E2"
      d="M22.747 4.345c.163.189.253.432.253.684v13.942c0 .568-.448 1.029-1 1.029-.245 0-.481-.093-.664-.26L15 14.639V17c0 1.105-.895 2-2 2H3c-1.105 0-2-.895-2-2V7c0-1.105.895-2 2-2h10c1.105 0 2 .895 2 2v2.36l6.336-5.1c.412-.378 1.044-.34 1.411.085zM13 7H3v10h10V7zm8 .321l-6 4.574v.211l6 4.574V7.32z" transform="translate(-1 -4)"
    />
  </g>
</svg>;

export const CamInActiveIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g fill="none" fillRule="evenodd">
    <path
      fill="#A2A4B2"
      d="M1.414 0l22 22L22 23.414l-7-7V17c0 1.105-.895 2-2 2H3c-1.105 0-2-.895-2-2V7c0-1.105.895-2 2-2l.584-.001 2 2L3 7v10h10v-2.586l-13-13L1.414 0zm21.333 4.345c.163.189.253.432.253.684v13.557l-2-2V7.321l-5.257 4.008L13 8.586V7l-1.587-.001-2-2L13 5c1.105 0 2 .895 2 2v2.36l6.336-5.1c.412-.378 1.044-.34 1.411.085z"
    />
  </g>
</svg>;


//──── Microphone ────────────────────────────────────────────────────────────────────────
export const MicIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="17" height="24" viewBox="0 0 17 24">
  <g fill="none" fillRule="evenodd">
    <path d="M0 0H24V24H0z" transform="translate(-3)" />
    <path
      fill="#4A90E2"
      fillRule="nonzero"
      d="M3.4 15.2c.6-.4 1.3-.2 1.5.4C6 18.3 8.6 20 11.4 20s5.4-1.7 6.5-4.3c.2-.6.9-.9 1.5-.5 1.5 1-1.7 4.7-4 5.8-.9.5-1.9.8-3 .9V24h-2v-2.1c-1.1-.1-2.1-.4-3-.9-1.9-.9-4.4-3.5-4.4-5 0-.3.1-.6.4-.8zm8-15.2c2.8 0 5 2.2 5 5v8c0 2.8-2.2 5-5 5s-5-2.2-5-5V5c0-2.8 2.2-5 5-5zm0 2c-1.7 0-3 1.3-3 3v8c0 1.7 1.3 3 3 3s3-1.3 3-3V5c0-1.7-1.3-3-3-3z" transform="translate(-3)"
    />
  </g>
</svg>;

export const MicInActiveIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g fill="none" fillRule="evenodd">
    <path
      fill="#A2A4B2"
      fillRule="nonzero"
      d="M3.5 15.1c.5-.2 1.1 0 1.3.6 1.1 2.6 3.6 4.3 6.5 4.3 1.9 0 3.7-.8 5-2.2l-1.4-1.4c-.9 1-2.2 1.6-3.6 1.6-2.8 0-5-2.2-5-5V7.8L0 1.4 1.5 0l21.8 22-1.4 1.4-4.2-4.2c-1.4 1.5-3.3 2.4-5.4 2.7V24h-2v-2.1C7 21.5 4.2 19.5 3 16.4c-.2-.5 0-1.1.5-1.3zm4.8-5.3V13c0 1.6 1.3 3 3 3 .9 0 1.6-.4 2.2-1L8.3 9.8zm6-4.8c0-1.6-1.4-3-3-3-1.4 0-2.6 1-2.9 2.3L6.9 2.8C7.7 1.1 9.4 0 11.3 0c2.7 0 5 2.2 5 5v7.2l-2-2V5z"
    />
  </g>
</svg>;


//──── Chat ──────────────────────────────────────────────────────────────────────────────
export const ChatIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22">
  <g fill="none" fillRule="evenodd">
    <path d="M0 0H24V24H0z" transform="translate(0 -2)" />
    <path
      fill="#4A90E2"
      fillRule="nonzero"
      d="M17 12h-2v-2h2v2zm-4 0h-2v-2h2v2zm-4-2v2H7v-2h2zM3 2h18c1.7 0 3 1.3 3 3v12c0 1.7-1.3 3-3 3H6.7c-.2 0-.4.1-.6.2l-4.5 3.6c-.2.1-.4.2-.6.2-.1 0-.3 0-.4-.1-.3-.2-.6-.5-.6-.9V5c0-1.7 1.3-3 3-3zM2 20.9l2.8-2.3c.6-.4 1.2-.6 1.9-.6H21c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v15.9z" transform="translate(0 -2)"
    />
  </g>
</svg>;

export const ChatInActiveIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g fill="none" fillRule="evenodd">
    <path
      fill="#A2A4B2"
      fillRule="nonzero"
      d="M1.5 0l21.8 22-1.4 1.4-3.385-3.4H6.7c-.2 0-.4.1-.6.2l-4.5 3.6c-.2.1-.4.2-.6.2-.08 0-.224 0-.33-.051L.6 23.9c-.3-.2-.6-.5-.6-.9V5c0-1.007.456-1.874 1.182-2.413L0 1.4 1.5 0zM2 5v15.9l2.8-2.3c.6-.4 1.2-.6 1.9-.6h9.825L9 10.441V12H7v-2h1.561L2.643 4.053C2.247 4.181 2 4.53 2 5zm19-3c1.7 0 3 1.3 3 3v12c0 .817-.3 1.542-.801 2.074l-1.409-1.422c.135-.169.21-.392.21-.652V5c0-.6-.4-1-1-1H8.263L6.281 2H21zm-4 8v2h-.81L15 10.799V10h2z"
    />
  </g>
</svg>;


//──── Share screen ──────────────────────────────────────────────────────────────────────
export const ScreenIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
  <g fill="none" fillRule="evenodd">
    <path d="M0 0H24V24H0z" transform="translate(0 -3)" />
    <path fill="#4A90E2" fillRule="nonzero" d="M22.5 3h-21C.7 3 0 3.7 0 4.5v13c0 .8.7 1.5 1.5 1.5h21c.8 0 1.5-.7 1.5-1.5v-13c0-.8-.7-1.5-1.5-1.5zM22 17H2V5h20v12zM7 23h10v-2H7v2z" transform="translate(0 -3)" />
  </g>
</svg>;

export const ScreenInActiveIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23">
  <g fill="none" fillRule="evenodd">
    <path fill="#A2A4B2" fillRule="nonzero" d="M17 21v2H7v-2h10zM2.414 0l21 21L22 22.414 18.584 19 1.5 19c-.753 0-1.417-.62-1.493-1.36L0 17.5v-13c0-.753.62-1.417 1.36-1.493L1.5 3l1.084-.001L1 1.414 2.414 0zM22.5 3c.753 0 1.417.62 1.493 1.36L24 4.5v13c0 .348-.132.677-.348.937L22 16.786V5H10.214l-2-2H22.5zm-5.916 13.999l-12-12L2 5v12l14.584-.001z" />
  </g>
</svg>;


//──── More details ──────────────────────────────────────────────────────────────────────
export const InfoIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g fill="none" fillRule="evenodd">
    <path fill="#4A90E2" fillRule="nonzero" d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10zM11 9h2V6h-2v3zm0 9h2v-7h-2v7z" />
  </g>
</svg>;

export const InfoInActiveIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g fill="none" fillRule="evenodd">
    <path fill="#A2A4B2" fillRule="nonzero" d="M1.414 0l22 22L22 23.414l-2.26-2.261C17.645 22.927 14.941 24 12 24 5.4 24 0 18.6 0 12c0-2.942 1.073-5.646 2.847-7.74L0 1.415 1.414 0zM2 12c0 5.5 4.5 10 10 10 2.392 0 4.594-.851 6.32-2.265L13 14.414V18h-2v-5.586L4.265 5.68C2.851 7.406 2 9.608 2 12zM12 0c6.6 0 12 5.4 12 12 0 2.225-.614 4.314-1.68 6.105l-1.468-1.468C21.585 15.25 22 13.671 22 12c0-5.5-4.5-10-10-10-1.67 0-3.25.415-4.637 1.148L5.895 1.68C7.686.614 9.775 0 12 0zm1 6v2.786l-2-2V6h2z" />
  </g>
</svg>;
